import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import React from 'react'
import Text from 'core/elements/Text'
import Theme from 'core/themes/model'
import FontAwesomeIcon from '../FontAwesomeIcon'
import { ErrorMessage } from '../validatedForm/ErrorMessage'

const useStyles = makeStyles<Theme>((theme) => ({
  successIcon: {
    color: theme.components.badge.success.color,
    marginRight: 8,
  },
  pendingIcon: {
    color: theme.components.badge.warning.color,
    marginRight: 8,
  },
  failedIcon: {
    color: theme.components.badge.error.color,
    marginRight: 8,
  },
  cloneProgress: {
    display: 'grid',
    gap: 16,
    padding: 16,
  },
  progressTable: {
    display: 'grid',
    gridTemplateColumns: 'max-content max-content max-content',
    gap: 16,
    padding: `0px 16px`,
    alignItems: 'center',
  },
  centered: {
    textAlign: 'center',
  },
}))

const progressIconByStatus = {
  success: 'check',
  pending: 'circle-notch',
  failed: 'xmark',
}

export enum ProgressStatus {
  Success = 'success',
  Pending = 'pending',
  Failed = 'failed',
}

export type ProgressDetails = {
  step: number
  label: string
  status: ProgressStatus
}

interface StepProgressProps {
  className?: string
  progressDetails: Array<ProgressDetails>
  title?: string
  errorMessage?: string
}

export const StepProgress = ({
  className = '',
  progressDetails = [],
  title = '',
  errorMessage = '',
}: StepProgressProps) => {
  const classes = useStyles()

  const getClassForStatus = React.useCallback(
    (status: ProgressStatus) => {
      switch (status) {
        case ProgressStatus.Success:
          return classes.successIcon
        case ProgressStatus.Pending:
          return classes.pendingIcon
        case ProgressStatus.Failed:
          return classes.failedIcon
        default:
          return null
      }
    },
    [classes],
  )

  return (
    <div className={clsx(classes.cloneProgress, className)}>
      <Text variant="body2">{title}</Text>
      {!!errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
      <div className={classes.progressTable}>
        {progressDetails.map((step) => (
          <React.Fragment key={step.step}>
            <Text variant="caption1">{step.step}.</Text>
            <Text variant="caption1">{step.label}</Text>
            <Text variant="body2" className={classes.centered}>
              <FontAwesomeIcon
                spin={step?.status === ProgressStatus.Pending}
                className={getClassForStatus(step?.status)}
              >
                {progressIconByStatus[step?.status]}
              </FontAwesomeIcon>
              {/* {step.status} */}
            </Text>
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}
